import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import urlSubscribe from 'app/Property/Detail/urlSubscribe';

import OfferWizardPopup from './offer';


export class OfferWizardLoader extends PureComponent {
  componentDidMount() {
    const { match = {}, openPopup, history, routes, urls, location } = this.props;
    // Extract property ID from URL since it can be in different positions
    // /search/:id/offer or /property/group/0/:id/offer
    let propertyId = match.params?.id;
    
    // Fallback: search for numeric ID in the path (just before 'offer')
    if (!propertyId && location?.pathname) {
      const idMatch = location.pathname.match(/\/(\d+)\/offer/);
      propertyId = idMatch ? idMatch[1] : null;
    }

    openPopup({
      onClose: () => {
        // Check if popup stored a redirect URL
        if (typeof window !== 'undefined' && window._offerRedirectUrl) {
          const redirectUrl = window._offerRedirectUrl;
          delete window._offerRedirectUrl;
          history.push(redirectUrl);
        } else {
          // fall back to stripping the '/offer' suffix from current location
          const pathname = location?.pathname || '';
          const base = pathname.split('/offer')[0];
          history.push(base || urls.getState().detailsRoot);
        }
      },
      urls,
      params: { id: propertyId },
      history,
      location,
      route: (routes && routes.length ? routes[routes.length - 1] : {}) || {},
    });
  }

  componentWillUnmount() {
    this.props.closePopup();
  }

  render() {
    return null;
  }
}

OfferWizardLoader.defaultProps = {
  params: {},
  history: {},
};

export default withRouter(
  connect(null, {
    openPopup: OfferWizardPopup.open,
    closePopup: OfferWizardPopup.close,
  })(urlSubscribe(OfferWizardLoader))
);
